export const AmbientLight = ({ lights }) =>
  lights.map((light, index) => <ambientLight {...light} key={index} />);
